import Bar from './BaseCharts/Bar';
import HorizontalBar from './BaseCharts/HorizontalBar';
import Doughnut from './BaseCharts/Doughnut';
import Line from './BaseCharts/Line';
import Pie from './BaseCharts/Pie';
import PolarArea from './BaseCharts/PolarArea';
import Radar from './BaseCharts/Radar';
import Bubble from './BaseCharts/Bubble';
import Scatter from './BaseCharts/Scatter';
import mixins from './mixins/index.js';
import npmCfg from '../package.json';
var VueCharts = {
  version: npmCfg.version,
  Bar: Bar,
  HorizontalBar: HorizontalBar,
  Doughnut: Doughnut,
  Line: Line,
  Pie: Pie,
  PolarArea: PolarArea,
  Radar: Radar,
  Bubble: Bubble,
  Scatter: Scatter,
  mixins: mixins
};
export default VueCharts;
export { VueCharts, Bar, HorizontalBar, Doughnut, Line, Pie, PolarArea, Radar, Bubble, Scatter, mixins };


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-chartjs/es/index.js
// module id = 42
// module chunks = 0